import React from 'react';
import {Box, Typography, Paper, Grid} from '@mui/material';
import {theme} from '../../../Theme';
import SecondaryButton from '../../../common/StyledComponents/SecondaryButton';
import PrimaryButton from '../../../common/StyledComponents/PrimaryButton';

const ServiceAreaWarning = (props: $TSFixMe) => {
  const warningText = `Hello Trendsetter! Thank you for posting a project with bidmii. 
  Your project is posted outside of Ontario, but we have not yet expanded nationwide. 
  For updates on expansions and other exciting bidmii news, subscribe to our newsletter. 
  For any questions you may have contact our customer support team.`;

  return (
    <Box p={3}>
      <Paper
        elevation={0}
        style={{
          background: theme.palette.pink.light,
          textAlign: 'center',
          padding: '16px 8px',
          width: 300,
          marginBottom: 24,
        }}>
        <Typography variant="caption">{warningText}</Typography>
      </Paper>
      <Grid container justifyContent="space-between">
        <SecondaryButton onClick={props.toggleServiceAreaWarning}>
          BACK
        </SecondaryButton>
        <PrimaryButton onClick={props.handleSubmit}>I UNDERSTAND</PrimaryButton>
      </Grid>
    </Box>
  );
};
export default ServiceAreaWarning;
